import * as tslib_1 from "tslib";
import { ElementRef, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { FcPaginatorComponent } from '@core/components/fc-paginator/fc-paginator.component';
import { Subject } from 'rxjs';
import { debounceTime, switchMap, takeUntil, tap } from 'rxjs/operators';
import { GroupService } from '../../../../services/groups-api.service';
var LinkUsersComponent = /** @class */ (function () {
    function LinkUsersComponent(groupId, dialogRef, groupsService) {
        this.groupId = groupId;
        this.dialogRef = dialogRef;
        this.groupsService = groupsService;
        this.page = null;
        this.isLoading = true;
        this.isAllSelected = false;
        this.currentPage = 0;
        this.pageSize = 5;
        this.isPageChanging = false;
        this.usersToAdd = new Map();
        this.linkAllUsers = false;
        this.reload = new Subject();
        this.subscriptions = new Subject();
        this.searchUsersInputValue = new FormControl();
    }
    LinkUsersComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.searchUsersInputValue.valueChanges.pipe(debounceTime(500)).subscribe(function () {
                    _this.isLoading = true;
                    if (_this.paginator) {
                        _this.paginator.firstPage();
                    }
                    else {
                        _this.reload.next();
                    }
                });
                this.reload.pipe(takeUntil(this.subscriptions), tap(function () { return _this.isLoading = true; }), switchMap(function () { return _this.searchAllUsers(); }), tap(function () {
                    _this.isLoading = false;
                })).subscribe(function (userPage) {
                    _this.page = userPage;
                });
                this.reload.next();
                return [2 /*return*/];
            });
        });
    };
    LinkUsersComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.next();
        this.subscriptions.complete();
    };
    LinkUsersComponent.prototype.checkIfIsAllSelected = function () {
        var _this = this;
        var users = (this.page && this.page.items) || [];
        return users.length && users.every(function (user) { return user.groupsConnection.items.length || _this.usersToAdd.has(user.id); });
    };
    LinkUsersComponent.prototype.toggleUserLinkedToGroup = function (checked, user) {
        if (this.linkAllUsers) {
            this.linkAllUsers = false;
            if (checked) {
                this.usersToAdd.set(user.id, true);
            }
            else {
                this.usersToAdd.delete(user.id);
            }
            this.isAllSelected = this.checkIfIsAllSelected();
            return;
        }
        if (checked) {
            this.usersToAdd.set(user.id, true);
        }
        else {
            this.usersToAdd.delete(user.id);
        }
        this.isAllSelected = this.checkIfIsAllSelected();
    };
    LinkUsersComponent.prototype.toggleAllSelected = function (checked) {
        var e_1, _a;
        var users = (this.page && this.page.items) || [];
        try {
            for (var users_1 = tslib_1.__values(users), users_1_1 = users_1.next(); !users_1_1.done; users_1_1 = users_1.next()) {
                var user = users_1_1.value;
                if (!user.groupsConnection.items.length) {
                    this.toggleUserLinkedToGroup(checked, user);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (users_1_1 && !users_1_1.done && (_a = users_1.return)) _a.call(users_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    LinkUsersComponent.prototype.onPageChange = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.currentPage = event.pageIndex;
                        this.isPageChanging = true;
                        _a = this;
                        return [4 /*yield*/, this.searchAllUsers()];
                    case 1:
                        _a.page = _b.sent();
                        this.isPageChanging = false;
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    LinkUsersComponent.prototype.searchAllUsers = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.groupsService.listAllUsers({
                        groupId: this.groupId,
                        offset: this.currentPage * this.pageSize,
                        limit: this.pageSize,
                        where: {
                            name_or_email_contains: this.searchUsersInputValue.value
                        }
                    })];
            });
        });
    };
    LinkUsersComponent.prototype.linkUsers = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.linkAllUsers) return [3 /*break*/, 2];
                        this.isLoading = true;
                        return [4 /*yield*/, this.groupsService.linkAllUsersToGroup({ groupId: this.groupId })];
                    case 1:
                        _a.sent();
                        this.isLoading = false;
                        this.dialogRef.close({
                            reload: true
                        });
                        return [2 /*return*/];
                    case 2: return [4 /*yield*/, this.groupsService.linkUsersToGroup({
                            groupId: this.groupId,
                            userId: Array.from(this.usersToAdd.keys())
                        })];
                    case 3:
                        _a.sent();
                        this.dialogRef.close({
                            reload: true
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    LinkUsersComponent.prototype.isAllLinkedUsers = function () {
        var users = (this.page && this.page.items) || [];
        return users.length > 0 && users.every(function (user) { return user.groupsConnection.items.length > 0; });
    };
    LinkUsersComponent.prototype.selectAllUsers = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.linkAllUsers = true;
                return [2 /*return*/];
            });
        });
    };
    return LinkUsersComponent;
}());
export { LinkUsersComponent };
